<template>
  <v-list
    id="dashboard-menu"
    class="sidebar-menu is-active animated preFadeInRIght fadeInRight"
  >
    <MainMenuEntry
      v-for="entry in menuEntries"
      :key="entry.location.name"
      :icon-name="entry.iconName"
      :icon-src="entry.iconSrc"
      :text="text[entry.location.name]"
      :location="entry.location"
    />
  </v-list>
</template>

<script setup lang="ts">
import { computed, Ref } from 'vue'
import { useRouter } from 'vue-router'

import { brelagUserRouteName } from '@/apps/brelag/mandator-user/app'
import { getLocationPreservingState } from '@/apps/routingUtils'
import MainMenuEntry from '@/components/navigation/MainMenuEntry.vue'
import { i18n } from '@/lang/setup'
import { CustomMandatorLayout } from '@/store/SettingsStore'
const router = useRouter()
const store = useStore()
import { useStore } from 'vuex'

const mandatorLayout: Ref<CustomMandatorLayout> = computed(
  () => store.getters['settings/mandatorLayout']
)

const menuEntries = computed(() => {
  let menuEntries = []
  if (mandatorLayout.value === CustomMandatorLayout.WESCO) {
    menuEntries = [
      {
        iconName: 'mdi-card-account-details',
        text: undefined,
        location: getLocationPreservingState(
          brelagUserRouteName('wesco-customer-root'),
          router
        ),
      },
      {
        iconName: 'mdi-folder-multiple',
        text: undefined,
        location: getLocationPreservingState(
          brelagUserRouteName('wesco-project-root'),
          router
        ),
      },
    ]
  } else {
    menuEntries = [
      {
        iconName: 'mdi-card-account-details',
        text: undefined,
        location: getLocationPreservingState(
          brelagUserRouteName('customer-root'),
          router
        ),
      },
      {
        iconName: 'mdi-folder-multiple',
        text: undefined,
        location: getLocationPreservingState(
          brelagUserRouteName('project-root'),
          router
        ),
      },
    ]
    menuEntries.push({
      text: 'KNOCKAUT',
      iconSrc: '/img/brelag/KA_Faust_black_white.svg',
      location: getLocationPreservingState(
        brelagUserRouteName('knockaut-list'),
        router
      ),
    })
  }

  return menuEntries
})

const text = computed(() => {
  return {
    [brelagUserRouteName('knockaut-list')]: 'KNOCKAUT',
    [brelagUserRouteName('customer-root')]: i18n.global.t(
      'apps.brelag.customer',
      2
    ),
    [brelagUserRouteName('project-root')]: i18n.global.t(
      'apps.brelag.project',
      2
    ),
    // WESCO
    [brelagUserRouteName('wesco-customer-root')]: i18n.global.t(
      'wesco.customer.prettyName',
      2
    ),
    [brelagUserRouteName('wesco-project-root')]: i18n.global.t(
      'wesco.project.prettyName',
      2
    ),
  }
})
</script>
